import { API_BASE_URL } from '../../utils/apiConfig';
import { isVdMartLocation, selectLocalCatalog } from '../../utils/vdMartPOS';
import { setBuyer, setCart } from './cartSlice';

// Identity is resolved at payment; all product prices still come from the local catalog.
export const preparePaymentBuyer = phoneNo => async (dispatch, getState) => {
  const state = getState();
  const user = state.posUser.userInfo;
  if (!isVdMartLocation(user?.location)) return;
  const selected = state.cart.buyer;
  if (!selected) throw new Error('Select the stakeholder before payment.');
  const response = await fetch(`${API_BASE_URL}/products-vdmart/pos-buyer?${new URLSearchParams({ phoneNo, stakeholderType: selected.stakeholderType, ...(selected.billingMode ? { billingMode: selected.billingMode } : {}), ...(selected.stakeholderType === 'outlet' ? { stakeholderId: selected.stakeholderId || '' } : {}) })}`, {
    headers: { Authorization: `Bearer ${user.token}` },
  });
  const resolved = await response.json();
  if (!response.ok) throw new Error(resolved.message || 'Buyer lookup failed');
  if (getState().cart !== state.cart) throw new Error('Cart changed. Please retry payment.');
  const buyer = { ...selected, ...resolved, phoneNo, stakeholderType: selected.stakeholderType };
  const products = selectLocalCatalog(state.products.raw, buyer);
  const items = state.cart.items.map(item => {
    const product = products.find(p => String(p._id) === String(item.productId || item.id));
    const detail = product?.details.find(d => String(d._id) === String(item.brandId));
    const rate = detail?.financials.find(f => String(f._id) === String(item.financialId));
    if (!rate) throw new Error(`Refresh the catalog: missing financials for ${item.item}.`);
    return { ...item, price: Number(rate.price), dprice: Number(rate.dprice), discount: Number(rate.Discount || 0),
      subtotal: Number((Number(rate.dprice) * item.qty).toFixed(2)) };
  });
  dispatch(setBuyer(buyer));
  dispatch(setCart({ buyer, items, total: Number(items.reduce((sum, item) => sum + item.subtotal, 0).toFixed(2)) }));
};
